import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const BetaDisclaimer = () => {
  const { t } = useLanguage();
  const whatToExpectItems = t('betaDisclaimer.whatToExpectItems', []);
  const howToHelpItems = t('betaDisclaimer.howToHelpItems', []);
  return (
    <section className="section-padding bg-white">
      <div className="container-max">
        <div className="max-w-4xl mx-auto">
          <div className="bg-gradient-to-r from-blue-50 to-purple-50 border-2 border-blue-200 rounded-2xl p-8 sm:p-12">
            <div className="text-center">
              {/* Warning Icon */}
              <div className="w-16 h-16 bg-gradient-to-r from-orange-500 to-red-500 rounded-full flex items-center justify-center mx-auto mb-6">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
                </svg>
              </div>
              
              {/* Title */}
              <h2 className="text-2xl sm:text-3xl font-bold text-orange-600 mb-4">
                {t('betaDisclaimer.title')}
              </h2>
              
              {/* Main Message */}
              <div className="bg-white/80 backdrop-blur-sm rounded-xl p-6 mb-6">
                <p className="text-lg sm:text-xl text-gray-800 leading-relaxed">
                  {t('betaDisclaimer.description')}
                </p>
              </div>
              
              {/* What to Expect */}
              <div className="grid md:grid-cols-2 gap-6 text-left">
                <div className="bg-white/60 backdrop-blur-sm rounded-xl p-6">
                  <h3 className="font-semibold text-orange-600 mb-3 flex items-center">
                    <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    {t('betaDisclaimer.whatToExpect')}
                  </h3>
                  {Array.isArray(whatToExpectItems) && (
                    <ul className="text-gray-700 text-sm space-y-2">
                      {whatToExpectItems.map((item) => (
                        <li key={item}>• {item}</li>
                      ))}
                    </ul>
                  )}
                </div>
                
                <div className="bg-white/60 backdrop-blur-sm rounded-xl p-6">
                  <h3 className="font-semibold text-orange-600 mb-3 flex items-center">
                    <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    {t('betaDisclaimer.howToHelp')}
                  </h3>
                  {Array.isArray(howToHelpItems) && (
                    <ul className="text-gray-700 text-sm space-y-2">
                      {howToHelpItems.map((item) => (
                        <li key={item}>• {item}</li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
              
              {/* Call to Action */}
              <div className="mt-8">
                <p className="text-gray-700 mb-4">
                  {t('betaDisclaimer.cta')}
                </p>
                <button 
                  onClick={() => {
                    const contactSection = document.getElementById('contact');
                    if (contactSection) {
                      contactSection.scrollIntoView({ behavior: 'smooth' });
                    }
                  }}
                  className="btn-secondary"
                >
                  {t('betaDisclaimer.button')}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BetaDisclaimer; 